module.exports = __webpack_public_path__ + "static/media/logo_seabank.c2f33a3e.svg";